<template>
	<div class="main">
		<!-- 设备回收 -->
		<div class="m-recover-box">
			<!-- 标题栏 -->
			<div class="recover-box-title">
				<div class="recover-box-title-left">
					<div class="big-title">设备回收</div>
					<div class="sm-title">高效/便捷/安全</div>
				</div>
				<button class="recover-box-title-right" @click="showMask">免费估价</button>
			</div>
			<!-- 分类 -->
			<div class="recover-classify">
				<!-- 回收类型 -->
				<ul class="classify-list">
					<li class="classify-item" :class="current==index?'active':''" v-for="(item,index) in recoverClass" :key="index" @click="clickClassItem(index)">
						{{item.title}}
					</li>
				</ul>
				<!-- 品牌列表 -->
				<div class="brand-nav">
					<div class="brand-item" 
						:class="index==brandCurrent?'brand-current':''" 
						v-for="(item,index) in recoverClass[current].brandNav" 
						:key="index"
						@click="brandCurrent=index">
						<img class="brand-logo" v-if="index<7" :src="item.img" alt="陌陌回收">
					</div>
					<div class="brand-item" @click="showMask">
						<img src="../assets/images/icon_more.png" alt="查看更多">
					</div>
				</div>
				<!-- 商品列表 -->
				<div class="brand-goods">
					<div class="goods-item" 
						v-for="(item,index) in recoverClass[current].brandNav[brandCurrent].goodsList"
						:key="index">
						<div class="item-img">
							<img class="goods-img" :src="item.img" alt="陌陌回收">
						</div>
						<div class="item-model">{{item.model}}</div>
						<div class="item-price">
							<span>最高回收价</span>
							<span class="price">￥{{item.price}}</span>
						</div>
						<div class="slide-group-show">
							<div class="slide-inner">
								<img src="../assets/images/wechat_QR.jpg" alt="陌陌回收">
								<p>微信扫码询价</p>
								<p>立项公众号专属加价券</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 每天都是回收日 -->
		<div class="m-default-box">
			<div class="m-main-title">
				<div class="title">每天都是回收日</div>
				<div class="line"></div>
				<div class="tag">二手轻松换成钱</div>
			</div>
			<div class="m-day-wrap">
				<div class="m-day-content">
					<div v-for="(item,index) in sliderList" :key="index" @click="showMask">
						<img class="slider-item" :src="item.img" alt="陌陌回收">
					</div>
				</div>
			</div>
		</div>
		
		<!-- 粉丝中的陌陌回收 -->
		<div class="m-default-box">
			<div class="m-main-title">
				<div class="title">粉丝心中的陌陌回收</div>
				<div class="line"></div>
				<div class="tag">陌陌回收4年，300万+的用户</div>
			</div>
			<div class="m-comment-warp">
				<div class="m-comment-content">
					<div class="comment-left">
						<el-carousel height="492px" :interval="5000" indicator-position="none" style="width: 100%;">
							<el-carousel-item v-for="(item2,index2) in commentList" :key="index2" style="width: 100%;">
								<div class="comment-column" v-for="(item,index) in item2" :key="index">
									<div class="comment-item" v-for="(item1,index1) in item" :key="index1">
										<div class="comment-item-top">
											<div class="user-img">
												<img :src="item1.uImg" :alt="item1.model">
											</div>
											<div class="user-info">
												<p style="font-size: 14px;">{{item1.uname}}</p>
												<p style="font-size: 16px;margin-top: 8px;">卖出了一台{{item1.model}}，赚了<span style="color: #fa3534;">¥{{item1.price}}</span>元</p>
											</div>
										</div>
										<div class="comment-item-bottom">
											{{item1.comment}}
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="comment-right">
						<div class="trade-header">
							<div class="line"></div>
							<div class="trade-title">实时交易动态</div>
							<div class="line"></div>
						</div>
						<div class="trade-list">
							<div class="trade-item" v-for="(item,index) in tradeList" :key="index" :style="{transition:transition,transform: moveY}">
								<div class="trade-item-img">
									<img :src="item.img" alt="陌陌回收">
								</div>
								<div class="trade-item-info">
									<p style="font-size: 18px">{{item.model}}</p>
									<p style="font-size: 14px;">{{item.phone}}成功回收</p>
									<p style="font-size: 12px; color: #999">回收最高价：<span class="trade-price" style="color: #f10e0e;">￥{{item.price}}</span></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 服务保障 -->
		<div class="m-default-box">
			<div class="m-main-title">
				<div class="title">服务保障</div>
				<div class="line"></div>
				<div class="tag">资深检测工程师，保证检测结果的公正性；先进的数据填充技术，保障用户隐私安全</div>
			</div>
			<div class="m-serve-warp">
				<div class="m-serve-content">
					<div v-for="(item,index) in serveList" :key="index">
						<img class="serve-img" :src="item.img" alt="陌陌回收">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				recoverClass: [
					{
						title:'手机',
						brandNav: [
							{
								brand: 'apple',
								img: require('../assets/images/logo_apple.png'),
								goodsList: [
									{model: '苹果 iPhone X 白色|大陆国行|A1865（全网通）|256GB',price:'2710.00',img:require('../assets/images/goods/apple/iPhoneX.png')},
									{model: '苹果 iPhone 7 大陆国行|黑色|A1660（全网通）|256GB',price:'1050.00',img:require('../assets/images/goods/apple/iPhone7.png')},
									{model: '苹果 iPhone 7 Plus 大陆国行|金色|A1661（全网通）|256GB',price:'1600.00',img:require('../assets/images/goods/apple/iPhone7Plus.png')},
									{model: '苹果 iPhone 6 Plus 大陆国行|黑色|A1524（全网通）|128GB',price:'680.00',img:require('../assets/images/goods/apple/iPhone6Plus.png')},
									{model: '苹果 iPhone 6 大陆国行|黑色|其他型号|128GB',price:'580.00',img:require('../assets/images/goods/apple/iPhone6.png')}
								]
							},
							{
								brand: 'huawei',
								img: require('../assets/images/logo_huawei.png'),
								goodsList: [
									{model: '华为 P40 Pro（5G版） 全网通|大陆国行|8G+512G',price:'4909.00',img:require('../assets/images/goods/huawei/huaweiP40Pro.png')},
									{model: '华为 Mate 30 Pro（5G版） 大陆国行|8G+512G',price:'4263.00',img:require('../assets/images/goods/huawei/huaweiMate30Pro.png')},
									{model: '华为 nova 7（5G版） 8G+256G|全网通|大陆国行',price:'2067.00',img:require('../assets/images/goods/huawei/huaweiNova7.png')},
									{model: '华为 Mate 20 Pro（UD）屏幕指纹版 大陆国行|全网通|8G+256G',price:'1938.00',img:require('../assets/images/goods/huawei/huaweiMate20Pro.png')},
									{model: '华为 P30 全网通|大陆国行|8G+256G',price:'1959.00',img:require('../assets/images/goods/huawei/huaweiP30.png')}
								]
							},
							{
								brand: 'xiaomi',
								img: require('../assets/images/logo_mi.png'),
								goodsList: [
									{model: '小米手机 10 Pro（5G版） 白色|12G+512G',price:'3666.00',img:require('../assets/images/goods/xiaomi/mi10Pro.png')},
									{model: '小米手机 9 Pro（5G版） 大陆国行|白色|12G+512G',price:'2141.00',img:require('../assets/images/goods/xiaomi/mi9Pro.png')},
									{model: '小米手机 9 大陆国行|全网通|12G+256G|透明',price:'1538.00',img:require('../assets/images/goods/xiaomi/mi9.png')},
									{model: 'Redmi K30 Pro 变焦版（5G版） 蓝色|12G+512G',price:'2347.00',img:require('../assets/images/goods/xiaomi/redmiK30Pro.png')},
									{model: '小米手机 10（5G版） 蓝色|12G+256G',price:'2746.00',img:require('../assets/images/goods/xiaomi/mi10.png')}
								]
							},
							{
								brand: 'vivo',
								img: require('../assets/images/logo_vivo.png'),
								goodsList: [
									{model: 'vivo NEX 3S（5G版） 液态天河|大陆国行|12G+256G',price:'2989.00',img:require('../assets/images/goods/vivo/vivoNex13S_5G.png')},
									{model: 'vivo S7（5G） 8G+256G',price:'1600.00',img:require('../assets/images/goods/vivo/vivoS7_5G.png')},
									{model: 'vivo V17 Pro',price:'948.00',img:require('../assets/images/goods/vivo/vivoV17.png')},
									{model: 'vivo X50 Pro（5G版） 8G+256G',price:'2753.00',img:require('../assets/images/goods/vivo/vivoX50Pro.png')},
									{model: 'vivo Y70s（5G版） 8G+128G',price:'1200.00',img:require('../assets/images/goods/vivo/vivoY70S.png')}
								]
							},
							{
								brand: 'oppo',
								img: require('../assets/images/logo_oppo.png'),
								goodsList: [
									{model: 'OPPO Reno4（5G版） 8G+256G',price:'1871.00',img:require('../assets/images/goods/oppo/oppoReno4_5G.png')},
									{model: 'OPPO Reno3 Pro（5G版） 大陆国行|红蓝|12G+256G',price:'2058.00',img:require('../assets/images/goods/oppo/oppoReno3Pro_5G.png')},
									{model: 'OPPO Reno2 大陆国行|8G+128G',price:'1175.00',img:require('../assets/images/goods/oppo/oppoReno2.png')},
									{model: 'OPPO R17 Pro 大陆国行|8G+128G|其他限量版',price:'1019.00',img:require('../assets/images/goods/oppo/oppoR17Pro.png')},
									{model: 'OPPO K5 绿色|8G+256G',price:'1170.00',img:require('../assets/images/goods/oppo/oppoK5.png')}
								]
							},
							{
								brand: 'honor',
								img: require('../assets/images/logo_honor.png'),
								goodsList: [
									{model: '荣耀 20 Pro 大陆国行|8G+256G',price:'1342.00',img:require('../assets/images/goods/honor/honor20Pro.png')},
									{model: '荣耀 30 Pro+（5G版） 12G+256G|大陆国行',price:'3606.00',img:require('../assets/images/goods/honor/honor30Pro_5G.png')},
									{model: '荣耀 Magic2 全网通|大陆国行|8G+256G',price:'1233.00',img:require('../assets/images/goods/honor/honorMagic2.png')},
									{model: '荣耀 Play4 Pro（5G版）',price:'1100.00',img:require('../assets/images/goods/honor/honorPlay4Pro.png')},
									{model: '荣耀 V30（5G版） 大陆国行|8G+128G',price:'1764.00',img:require('../assets/images/goods/honor/honorV30.png')}
								]
							},
							{
								brand: 'meizu',
								img: require('../assets/images/logo_meizu.png'),
								goodsList: [
									{model: '魅族 15 Plus 金色|大陆国行|6G+128G',price:'750.00',img:require('../assets/images/goods/meizu/meizu15Plus.jpg')},
									{model: '魅族 16X 大陆国行|6G+128G',price:'680.00',img:require('../assets/images/goods/meizu/meizu16X.png')},
									{model: '魅族 Note8 4G+64G',price:'400.00',img:require('../assets/images/goods/meizu/meizuNode8.png')},
									{model: '魅族 魅蓝 Note 6 64G',price:'265.00',img:require('../assets/images/goods/meizu/meizuNote6.png')},
									{model: '魅族 PRO6 Plus 4G+128G',price:'370.00',img:require('../assets/images/goods/meizu/meizuPro6Plus.jpg')}
								]
							},
						]
					},
					{
						title:'平板',
						brandNav: [
							{
								brand: 'apple',
								img: require('../assets/images/logo_apple.png'),
								goodsList: [
									{model: 'iPad Pro 11寸 2代 2020款 WIFI+4G|1TB',price:'8800.00',img:require('../assets/images/goods/apple/iPadPro2020.png')},
									{model: 'iPad Pro 12.9寸 4代 2020款 WIFI+4G|1TB',price:'7740.00',img:require('../assets/images/goods/apple/iPadPro2020_12.7.png')},
									{model: 'iPad Air2 128GB',price:'1220.00',img:require('../assets/images/goods/apple/iPadAir2.png')},
									{model: 'iPad Pro 12.9寸 2代 2017款 WIFI+4G|512GB',price:'3350.00',img:require('../assets/images/goods/apple/iPadPro2017.png')},
									{model: 'iPad Air3 WIFI+4G|256GB',price:'3060.00',img:require('../assets/images/goods/apple/iPadMini2.png')}
								]
							},
							{
								brand: 'huawei',
								img: require('../assets/images/logo_huawei.png'),
								goodsList: [
									{model: '华为 MatePad Pro 橙色|8G+512G|WIFI+5G',price:'4035.00',img:require('../assets/images/goods/huawei/huaweiMatePadPro.png')},
									{model: '华为 MatePad 6G+128G|WIFI+4G',price:'1280.00',img:require('../assets/images/goods/huawei/huaweiMatePad_128.png')},
									{model: '华为平板 M6 8.4英寸 高能版 WIFI+4G',price:'1580.00',img:require('../assets/images/goods/huawei/huaweiPadM6.png')},
									{model: '华为平板 M5 Pro WIFI+4G',price:'910.00',img:require('../assets/images/goods/huawei/huaweiPadM5.png')},
									{model: '华为平板 M3 128G|WIFI+4G',price:'610.00',img:require('../assets/images/goods/huawei/huaweiMatePadM3.png')}
								]
							},
							{
								brand: 'xiaomi',
								img: require('../assets/images/logo_mi.png'),
								goodsList: [
									{model: '小米平板4 Plus 128G',price:'1320.00',img:require('../assets/images/goods/xiaomi/miPad4Plus.png')},
									{model: '小米平板4 64G|WIFI+4G',price:'760.00',img:require('../assets/images/goods/xiaomi/miPad4.png')},
									{model: '小米平板 3 不分版本',price:'437.00',img:require('../assets/images/goods/xiaomi/miPad3.png')},
									{model: '小米平板2 64G',price:'287.00',img:require('../assets/images/goods/xiaomi/miPad2.jpg')},
									{model: '小米平板 64G',price:'237.00',img:require('../assets/images/goods/xiaomi/miPad1.png')}
								]
							},
							{
								brand: 'lenovo',
								img: require('../assets/images/logo_lenovo.png'),
								goodsList: [
									{model: '联想Yoga Tab3 Plus 不分版本',price:'312.00',img:require('../assets/images/goods/lenovo/lenovoYOGATab3Plus.png')},
									{model: '联想YOGA Tab 5（YT-X705） 大陆国行',price:'805.00',img:require('../assets/images/goods/lenovo/lenovoYOGATab5.png')},
									{model: '联想YOGA Tab 3 Pro 不分版本',price:'505.00',img:require('../assets/images/goods/lenovo/lenovoYOGATab3.png')},
									{model: '联想 Tab M8 WIFI+4G',price:'372.00',img:require('../assets/images/goods/lenovo/lenovoTabM8.png')},
									{model: '联想 小新平板 10.1英寸(TB-X804F) 不分版本',price:'362.00',img:require('../assets/images/goods/lenovo/lenovoTab8.png')}
								]
							},
							{
								brand: 'honor',
								img: require('../assets/images/logo_honor.png'),
								goodsList: [
									{model: '荣耀X2 128G|WIFI',price:'417.00',img:require('../assets/images/goods/honor/honorPadX2_128.png')},
									{model: '荣耀平板5 10.1英寸 64G|WIFI+4G',price:'610.00',img:require('../assets/images/goods/honor/honorPad2.png')},
									{model: '荣耀畅玩平板2 9.6英寸 WIFI+4G|32G',price:'347.00',img:require('../assets/images/goods/honor/honorPadPlay.png')},
									{model: '荣耀Waterplay防水影音平板 10.1英寸 64G|WIFI',price:'510.00',img:require('../assets/images/goods/honor/honorPadWater.png')},
									{model: '荣耀平板5 8英寸 WIFI|128G',price:'510.00',img:require('../assets/images/goods/honor/honorPad5.png')}
								]
							},
							{
								brand: 'samsung',
								img: require('../assets/images/logo_samsung.png'),
								goodsList: [
									{model: '三星Galaxy Tab S6 WIFI+4G|8G+256G',price:'3385.00',img:require('../assets/images/goods/samsung/GalaxyTabS6.png')},
									{model: '三星Galaxy Tab S5e 128G|WIFI+4G',price:'1760.00',img:require('../assets/images/goods/samsung/GalaxyTabS5e.png')},
									{model: '三星Galaxy Tab S4(T830/T835/T837) 256G|WIFI+4G',price:'1960.00',img:require('../assets/images/goods/samsung/GalaxyTabS4.png')},
									{model: '三星Galaxy Tab S3(T820/T825/T827) WIFI+4G',price:'1020.00',img:require('../assets/images/goods/samsung/GalaxyTabS3.png')},
									{model: '三星Galaxy Tab A 10.5(T590/T595) WIFI+4G',price:'710.00',img:require('../assets/images/goods/samsung/GalaxyTabA.png')}
								]
							},
							{ 
								brand: 'acer',
								img: require('../assets/images/logo_acer.png'),
								goodsList: [
									{model: 'Acer Iconia A3 不分版本',price:'52.00',img:require('../assets/images/goods/acer/acerIconia_A3.jpg')}
								]
							},
						]
					},
					{
						title:'电脑',
						brandNav: [
							{
								brand: 'apple',
								img: require('../assets/images/logo_apple.png'),
								goodsList: [
									{model: '苹果 15年 15寸 MacBook Pro 2.8GHz Intel Core i7|AMD M370X+Intel Iris Pro',price:'5550.00',img:require('../assets/images/goods/apple/MacBookPro15_2.png')},
									{model: '苹果 16年 15寸 MacBook Pro 2.9GHz Intel Core i7|Radeon Pro 460+Intel HD',price:'7590.00',img:require('../assets/images/goods/apple/MacBookPro15.png')},
									{model: '苹果 16年 13寸 MacBook Pro 3.3GHz Intel Core i7|16GB|Intel Iris Graphics 550',price:'6550.00',img:require('../assets/images/goods/apple/MacBookPro13.png')},
									{model: '苹果 18年 13寸 MacBook Pro 2.7GHz Intel Core i7|16GB|大陆国行',price:'8550.00',img:require('../assets/images/goods/apple/MacBookPro.png')},
									{model: '苹果 12年 13寸 MacBook Air 2GHz Intel Core i7|8GB',price:'2220.00',img:require('../assets/images/goods/apple/MacBookAir.png')}
								]
							},
							{
								brand: 'huawei',
								img: require('../assets/images/logo_huawei.png'),
								goodsList: [
									{model: '华为 MateBook 13 2020款 2G独立显卡|16GB|Intel 酷睿 i7 10代',price:'4260.00',img:require('../assets/images/goods/huawei/huaweiMateBook13.png')},
									{model: '华为 MateBook 14 2020款 16GB|3G独立显卡|Intel 酷睿 i7 10代',price:'4820.00',img:require('../assets/images/goods/huawei/huaweiMateBook14.png')},
									{model: '华为 MateBook D 15寸 系列 32GB及以上|2G独立显卡|Intel 酷睿 i7 10代',price:'3820.00',img:require('../assets/images/goods/huawei/huaweiMateBookD.png')},
									{model: '华为 MateBook E 系列 高通骁龙 850|8GB',price:'2320.00',img:require('../assets/images/goods/huawei/huaweiMateBookE.png')},
									{model: '华为 MateBook X Pro 2020款 2G独立显卡|Intel 酷睿 i7 10代',price:'7250.00',img:require('../assets/images/goods/huawei/huaweiMateBookX.png')}
								]
							},
							{
								brand: 'xiaomi',
								img: require('../assets/images/logo_mi.png'),
								goodsList: [
									{model: '小米 RedmiBook 13 系列 2G独立显卡|Intel 酷睿 i7 10代',price:'2420.00',img:require('../assets/images/goods/xiaomi/redmiBook13.png')},
									{model: '小米笔记本Air 13.3寸 Intel 酷睿 i5 8代|2G独立显卡|8GB',price:'2100.00',img:require('../assets/images/goods/xiaomi/miBookAir.png')},
									{model: '小米 RedmiBook 14 系列 2G独立显卡|16GB-18GB|Intel 酷睿 i7 10代',price:'3120.00',img:require('../assets/images/goods/xiaomi/redmiBook14.png')},
									{model: '小米笔记本 15.6寸 Intel 酷睿 i7 8代|16GB-18GB|2G独立显卡',price:'2120.00',img:require('../assets/images/goods/xiaomi/miBookInter.png')},
									{model: '小米笔记本Pro 15.6寸 Intel 酷睿 i7 10代|16GB-18GB|2G独立显卡',price:'3920.00',img:require('../assets/images/goods/xiaomi/miBookPro.png')}
								]
							},
							{
								brand: 'lenovo',
								img: require('../assets/images/logo_lenovo.png'),
								goodsList: [
									{model: '联想 Thinkpad L390 系列 32GB及以上|Intel 酷睿 i7 8代',price:'5450.00',img:require('../assets/images/goods/lenovo/Thinkpad_L390.png')},
									{model: '联想ThinkPad P51 系列 Intel 酷睿 i7 7代|32GB及以上|4G独立显卡',price:'5450.00',img:require('../assets/images/goods/lenovo/ThinkPad_P51.png')},
									{model: '联想 Yoga S940 16GB-18GB|Intel 酷睿 i7 10代',price:'5650.00',img:require('../assets/images/goods/lenovo/Yoga_S940.png')},
									{model: '联想ThinkPad X1 Tablet Evo(3rd Gen) 系列 Intel 酷睿 i7 8代|16GB-18GB',price:'5050.00',img:require('../assets/images/goods/lenovo/ThinkPad_X1.png')},
									{model: '联想 ThinkPad X1 Carbon 2019 Intel 酷睿 i7 10代|16GB-18GB|6G独立显卡',price:'8850.00',img:require('../assets/images/goods/lenovo/ThinkPad_X1_Carbon.png')}
								]
							},
							{
								brand: 'dell',
								img: require('../assets/images/logo_dell.png'),
								goodsList: [
									{model: '戴尔 Inspiron灵越 15 7567(游匣7000) 系列 Intel 酷睿 i7 7代|32GB及以上|4G独立显卡',price:'3438.00',img:require('../assets/images/goods/dell/Inspiron_15_7567.png')},
									{model: '戴尔 Inspiron灵越 14 7460(燃7000) 系列 Intel 酷睿 i5 8代|16GB-18GB|4G独立显卡',price:'2763.00',img:require('../assets/images/goods/dell/Inspiron_14_7460.png')},
									{model: '戴尔 Inspiron灵越 15 5557 系列 Intel 酷睿 i7 6代|16GB-18GB|4G独立显卡',price:'2448.00',img:require('../assets/images/goods/dell/Inspiron_15_5557.png')},
									{model: '戴尔 XPS 13 9350 系列(非触控版) Intel 酷睿 i7 6代|16GB-18GB',price:'2448.00',img:require('../assets/images/goods/dell/XPS_13_9350.png')},
									{model: '戴尔 Inspiron灵越 15 7560(燃7000) 系列 Intel 酷睿 i7 7代|16GB-18GB|4G独立显卡',price:'2358.00',img:require('../assets/images/goods/dell/Inspiron_15_7560.png')}
								]
							},
							{
								brand: 'acer',
								img: require('../assets/images/logo_acer.png'),
								goodsList: [
									{model: 'Acer 暗影骑士3 VX5-591G 系列 Intel 酷睿 i7 7代|16GB-18GB|4G独立显卡',price:'2520.00',img:require('../assets/images/goods/acer/Acer_VN7_591G.png')},
									{model: 'Acer 暗影骑士2 VN7-592G 系列 Intel 酷睿 i7 6代|16GB-18GB|4G独立显卡',price:'2020.00',img:require('../assets/images/goods/acer/Acer_VN7_592G.png')},
									{model: 'Acer TMP278 系列 Intel 酷睿 i7 6代|8GB|4G独立显卡',price:'1450.00',img:require('../assets/images/goods/acer/Acer_TMP278.png')},
									{model: 'Acer 暗影骑士 VN7-591G 系列 Intel 酷睿 i7 4代|16GB-18GB|4G独立显卡',price:'1910.00',img:require('../assets/images/goods/acer/Acer_VN7_591G.png')},
									{model: 'Acer 掠夺者G9-791 系列 32GB及以上',price:'1950.00',img:require('../assets/images/goods/acer/Acer_G9_791.png')}
								]
							},
							{
								brand: 'samsung',
								img: require('../assets/images/logo_samsung.png'),
								goodsList: [
									{model: '三星 玄龙骑士8500GM 系列 Intel 酷睿 i7 7代|16GB-18GB|4G独立显卡',price:'2080.00',img:require('../assets/images/goods/samsung/8500GM.png')},
									{model: '三星 900X3N 系列 Intel 酷睿 i7 7代|16GB-18GB',price:'2358.00',img:require('../assets/images/goods/samsung/900X3N.png')},
									{model: '三星 玄龙骑士810G5M 系列 Intel 酷睿 i7 7代|10GB-14GB',price:'2412.00',img:require('../assets/images/goods/samsung/810G5M.png')},
									{model: '三星 900X3J 系列 Intel 酷睿 i7 7代',price:'1908.00',img:require('../assets/images/goods/samsung/900X3J.png')},
									{model: '三星 870Z5G Intel 酷睿 i7 4代',price:'1179.00',img:require('../assets/images/goods/samsung/870Z5G.png')}
								]
							},
						]
					},
					{
						title:'手表',
						brandNav: [
							{
								brand: 'apple',
								img: require('../assets/images/logo_apple.png'),
								goodsList: [
									{model: 'Apple Watch Nike(Series 5)',price:'2875.00',img:require('../assets/images/goods/apple/iwatch_Nike5.jpg')},
									{model: 'Apple Watch Series 5',price:'3099.00',img:require('../assets/images/goods/apple/iwatch_Series5.jpg')},
									{model: 'Apple Watch Series 3',price:'2099.00',img:require('../assets/images/goods/apple/iwatch_Series5.jpg')},
									{model: 'Apple Watch Nike(Series 3)',price:'966.00',img:require('../assets/images/goods/apple/iwatch_Nike3.jpg')},
									{model: 'Apple Watch Nike(Series 4)',price:'2220.00',img:require('../assets/images/goods/apple/iwatch_Nike4.jpg')}
								]
							},
							{
								brand: 'huawei',
								img: require('../assets/images/logo_huawei.png'),
								goodsList: [
									{model: '华为 WATCH GT2(46mm)砂砾棕',price:'879.00',img:require('../assets/images/goods/huawei/WATCH_GT2e.png')},
									{model: '华为 WATCH GT2曜石黑男款',price:'694.00',img:require('../assets/images/goods/huawei/WATCH_GT2.jpg')},
									{model: '华为 WATCH GT2时尚女款',price:'1154.00',img:require('../assets/images/goods/huawei/WATCH_GT2_Woman.jpg')},
									{model: '华为 WATCH 2 Pro保时捷版',price:'2059.00',img:require('../assets/images/goods/huawei/WATCH_2_Pro.jpg')},
									{model: '华为 WATCH GT1雅致款',price:'1215.00',img:require('../assets/images/goods/huawei/WATCH_GT1.jpg')}
								]
							},
							{
								brand: 'xiaomi',
								img: require('../assets/images/logo_mi.png'),
								goodsList: [
									{model: '小米手表',price:'644.00',img:require('../assets/images/goods/xiaomi/XMWT01.jpg')},
									{model: '小米手环4',price:'96.00',img:require('../assets/images/goods/xiaomi/XMSH04.jpg')},
									{model: '小米手环5',price:'105.00',img:require('../assets/images/goods/xiaomi/XMSH05.jpg')},
									{model: '小米手表color运动智能手表',price:'287.00',img:require('../assets/images/goods/xiaomi/XMWT_Color.jpg')},
									{model: '小米米兔儿童电话手表4C',price:'115.00',img:require('../assets/images/goods/xiaomi/XMWTTU.jpg')}	
								]
							},
							{
								brand: 'samsung',
								img: require('../assets/images/logo_samsung.png'),
								goodsList: [
									{model: '三星 Galaxy Watch3智能电话手表',price:'2289.00',img:require('../assets/images/goods/samsung/Galaxy_Watch3.jpg')},
									{model: '三星 Samsung Galaxy watch LTE版 智能手表 5ATM防水',price:'1459.00',img:require('../assets/images/goods/samsung/Galaxy_watch_LTE.jpg')},
									{model: '三星 Galaxy watch active2智能运动手表',price:'1387.00',img:require('../assets/images/goods/samsung/Galaxy_Watch_Active2.jpg')},
									{model: '三星 Galaxy Watch智能手表Gear S4 LTE蜂窝板',price:'648.00',img:require('../assets/images/goods/samsung/Galaxy_Watch_Gear_S4_LTE.jpg')},
									{model: '三星Galaxy Watch 智能手表男成人gear S4运动手表',price:'715.00',img:require('../assets/images/goods/samsung/Galaxy_Watch_gear_S4.jpg')}	
								]
							}
						],
					},
					{
						title:'电子书',
						brandNav: [
							{
								brand: 'Kindle',
								img: require('../assets/images/logo_kindle.png'),
								goodsList: [
									{model: 'Kindle Paperwhite4墨水屏电子书阅读器',price:'438.00',img:require('../assets/images/goods/kindle/Kindle_Paperwhite4.jpg')},
									{model: 'Kindle青春版 墨水屏电子书阅读器',price:'254.00',img:require('../assets/images/goods/kindle/Kindle_Young.jpg')},
									{model: 'Kindle 青春版8G',price:'189.00',img:require('../assets/images/goods/kindle/Kindle_Enter.png')}
								]
							}
						]
					}
				],
				current: 0,
				brandCurrent: 0,
				sliderList: [
					{img:require('../assets/images/lunbo1.png')},
					{img:require('../assets/images/lunbo2.png')},
					{img:require('../assets/images/lunbo3.png')}
				],
				serveList: [
					{img:require('../assets/images/img_shunfeng.png')},
					{img:require('../assets/images/img_zhijian.png')},
					{img:require('../assets/images/img_yinsi.png')},
					{img:require('../assets/images/img_gaojia.png')}
				],
				tradeList: [
					{model:'魅族 16X',price:'903',phone:'189****4871',img:require('../assets/images/goods/meizu/meizu16X.png')},
					{model:'iPhone 7 Plus',price:'2032',phone:'159****1214',img:require('../assets/images/goods/apple/iPhone7Plus.png')},
					{model:'iPhone 6',price:'859',phone:'188****8557',img:require('../assets/images/goods/apple/iPhone6.png')},
					
					{model:'iPhone X',price:'3758',phone:'131****9623',img:require('../assets/images/goods/apple/iPhoneX.png')},
					{model:'华为 P10',price:'680',phone:'151****9440',img:require('../assets/images/goods/huawei/huaweiP10.png')},
					{model:'小米 9',price:'1954',phone:'135****8557',img:require('../assets/images/goods/xiaomi/mi9.png')},
					{model:'荣耀 20 Pro',price:'1567',phone:'199****8219',img:require('../assets/images/goods/honor/honor20Pro.png')},
					{model:'vivo S7(5G)',price:'1650',phone:'158****3399',img:require('../assets/images/goods/vivo/vivoS7_5G.png')},
					{model:'魅族 16X',price:'903',phone:'189****4871',img:require('../assets/images/goods/meizu/meizu16X.png')},
					{model:'iPhone 7 Plus',price:'2032',phone:'159****1214',img:require('../assets/images/goods/apple/iPhone7Plus.png')},
					{model:'iPhone 6',price:'859',phone:'188****8557',img:require('../assets/images/goods/apple/iPhone6.png')},
					
					{model:'iPhone X',price:'3758',phone:'131****9623',img:require('../assets/images/goods/apple/iPhoneX.png')},
				],
				commentList: [
					[
						[
							{
								uname: '萨丁x',
								uImg: require('../assets/images/uImg/uimg_01.jpg'),
								model: 'iPhone X',
								price: 3240,
								comment: '回收了个苹果X，非常nice'
							},
							{
								uname: '威菀',
								uImg: require('../assets/images/uImg/uimg_02.png'),
								model: '小米 8',
								price: 1275,
								comment: '不错，顶一个，谁要你这么诚信呢。。呵呵谢谢咯！'
							},
							{
								uname: '丑北辰',
								uImg: require('../assets/images/uImg/uimg_03.jpg'),
								model: 'vivo Y3',
								price: 416,
								comment: '经过我的亲身体验，这个平台信誉是相当地不错，价格合理，太感谢了！'
							},
						],
						[
							{
								uname: '小情绪',
								uImg: require('../assets/images/uImg/uimg_04.jpg'),
								model: 'OPPO A5',
								price: 496,
								comment: '以后卖手机还来派派回哦！'
							},
							{
								uname: '花巷',
								uImg: require('../assets/images/uImg/uimg_05.jpg'),
								model: '荣耀 8X',
								price: 345,
								comment: '真不错，快递速度很快，服务到位！'
							},
							{
								uname: 'Sunshine',
								uImg: require('../assets/images/uImg/uimg_06.jpg'),
								model: 'iPhone 7',
								price: 1081,
								comment: '真是很值得哦.... 什么都很好..'
							},
						],
						[
							{
								uname: '无人街角',
								uImg: require('../assets/images/uImg/uimg_07.jpg'),
								model: '小米 9',
								price: 1617,
								comment: '老客户了啊，希望以后有更多好东东'
							},
							{
								uname: '帅锅有罪',
								uImg: require('../assets/images/uImg/uimg_08.jpg'),
								model: 'iPad 6代',
								price: 1314,
								comment: '发货很快，东西不错，'
							},
							{
								uname: 'Angel',
								uImg: require('../assets/images/uImg/uimg_09.jpg'),
								model: 'iPhone XR',
								price: 2656,
								comment: '好沟通，爽快，不墨迹，确认快，重信用'
							},
						]
					],
					[
						[
							{
								uname: 'Moon',
								uImg: require('../assets/images/uImg/uimg_11.jpg'),
								model: 'OPPO A9',
								price: 530,
								comment: '陌陌回收平台不错，不坑人，强烈推荐'
							},
							{
								uname: '你好瞎i',
								uImg: require('../assets/images/uImg/uimg_12.jpg'),
								model: 'realme 真我V5',
								price: 930,
								comment: '二手手机估这个价很满意，咨询了客服直接进行交易'
							},
							{
								uname: 'Afraid',
								uImg: require('../assets/images/uImg/uimg_13.jpg'),
								model: 'iPhone 6s Plus',
								price: 402,
								comment: '用了几年的苹果6s卖了402，非常满意'
							},
						],
						[
							{
								uname: '胡撸娃',
								uImg: require('../assets/images/uImg/uimg_14.jpg'),
								model: 'vivo X27',
								price: 529,
								comment: '客服态度很好，旧手机卖出去了'
							},
							{
								uname: '开着拖拉机去私奔',
								uImg: require('../assets/images/uImg/uimg_15.jpg'),
								model: '美图 T9',
								price: 701,
								comment: '朋友介绍，客服服务态度好，效率高'
							},
							{
								uname: 'Devil',
								uImg: require('../assets/images/uImg/uimg_16.jpg'),
								model: '荣耀 9',
								price: 205,
								comment: '回收流程方便，不存在压价，卖二手的好去处'
							},
						],
						[
							{
								uname: '毒',
								uImg: require('../assets/images/uImg/uimg_17.jpg'),
								model: '荣耀 9X',
								price: 864,
								comment: '专业鉴定，让我成功卖出了闲置的手机'
							},
							{
								uname: '远妄',
								uImg: require('../assets/images/uImg/uimg_18.jpg'),
								model: '联想 E40-70',
								price: 325,
								comment: '第二次来了，价格很满意，快递上门取件很方便'
							},
							{
								uname: '康忙北鼻',
								uImg: require('../assets/images/uImg/uimg_19.jpg'),
								model: '黑鲨 2',
								price: 2097,
								comment: '整个回收很快，确认收货后很快就打款了'
							},
						]
					],
					[
						[
							{
								uname: '西瓜君#',
								uImg: require('../assets/images/uImg/uimg_20.jpg'),
								model: '荣耀 V30',
								price: 1948,
								comment: '个人觉得陌陌回收还是挺方便的，在线估价，顺丰包邮'
							},
							{
								uname: '二友',
								uImg: require('../assets/images/uImg/uimg_21.jpg'),
								model: '小米 8SE',
								price: 700,
								comment: '本来是试用，看到估价不错就卖了，以后就用陌陌回收'
							},
							{
								uname: '贱男村村长',
								uImg: require('../assets/images/uImg/uimg_22.jpg'),
								model: 'OPPO A9',
								price: 530,
								comment: '第一次在陌陌回收卖手机~过程蛮愉快的，价格也给的合适！'
							},
						],
						[
							{
								uname: 'Healer',
								uImg: require('../assets/images/uImg/uimg_23.jpg'),
								model: 'iPhone 8',
								price: 1252,
								comment: '在线估价，最后的质检价格也没让我失望'
							},
							{
								uname: '失心疯',
								uImg: require('../assets/images/uImg/uimg_24.jpg'),
								model: '荣耀 Note10',
								price: 950,
								comment: '近期刚换了新手机，正好把旧手机处理的，回收价不错挺高的'
							},
							{
								uname: '再见不见',
								uImg: require('../assets/images/uImg/uimg_25.jpg'),
								model: '魅族 16T',
								price: 1464,
								comment: '第一次用这个方式回收手机，一次很好的体验，靠谱'
							},
						],
						[
							{
								uname: '无视上课铃ing',
								uImg: require('../assets/images/uImg/uimg_26.jpg'),
								model: '荣耀 Play3',
								price: 660,
								comment: '客服帮你预约顺丰上门取件还包邮，十分方便，质检的流程也快'
							},
							{
								uname: 'Poison',
								uImg: require('../assets/images/uImg/uimg_27.jpg'),
								model: '一加8 Pro',
								price: 3609,
								comment: '真的让我解决闲置手机~整个流程都很顺利，关键是价格合适'
							},
							{
								uname: '放肆小青年',
								uImg: require('../assets/images/uImg/uimg_10.jpg'),
								model: 'vivo S5',
								price: 1121,
								comment: '一个好用的回收手机平台，工作人员处理很快，价格也很公道，回收款很快到账'
							},
						]
					],
				],
				transition:'all 0.5',
				index: 3,
				moveY:'translateY(-300%)',
				commentTime: null,
			}
		},
		
		methods:{
			clickClassItem(index){
				this.current = index
				this.brandCurrent = 0
			},
			
			// 自动轮播评价
			playComment(){
				clearInterval(this.commentTime)
				this.commentTime = setInterval(()=>{
					if(this.index<0){
						this.index = this.tradeList.length - 4
						this.transition = 'none'
					}else{
						this.transition = 'all 0.8s'
					}
					let move = -117 * this.index + 'px'
					this.moveY = `translateY(${move})`
					this.index --
				},4000)
			},
			
			showMask(){
				this.$emit('showMask',true)
			}
		},
		
		mounted() {
			this.playComment()
		}
	}
</script>

<style>
*{
	padding: 0;
	margin: 0;
}
	
li{
	list-style: none;
}

.m-recover-box{
	width: 1226px;
	margin: 30px auto 0;
	background-color: #fff;
	box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
}

.m-recover-box .recover-box-title{
	height: 58px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.m-recover-box .recover-box-title .recover-box-title-left{
	display: flex;
	align-items: flex-end;
	margin-left: 23px;
}

.m-recover-box .recover-box-title-left .big-title{
	font-size: 24px;
	margin-right: 10px;
}

.m-recover-box .recover-box-title-left .sm-title{
	color: #808080;
	font-size: 16px;
}

.m-recover-box .recover-box-title .recover-box-title-right{
	width: 150px;
	height: 40px;
	background-color: #3C78EB;
	border-radius: 3px;
	color: #fff;
	font-size: 18px;
	text-align: center;
	line-height: 40px;
	margin-right: 10px;
	outline: none;
	border: none;
	cursor: pointer;
}

.recover-classify{
	
}

.recover-classify .classify-list{
	display: flex;
	padding: 0;
}

.recover-classify .classify-list .classify-item{
	flex: 1;
	height: 50px;
	text-align: center;
	line-height: 50px;
	font-size: 18px;
	cursor: pointer;
	transition: all 0.3s;
}

.active{
	color: #fff;
	background-color: #3C78EB;
}

.recover-classify .brand-nav{
	display: flex;
}

.recover-classify .brand-item{
	width: 153px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f5f5f5;
	padding: 12px 0;
	filter: grayscale(100%);
	cursor: pointer;
	transition: all 0.1s;
}

.recover-classify .brand-item .brand-logo{
	width: 92px;
	height: 34px;
}

.brand-current{
	background-color: #fff !important;
	filter: grayscale(0) !important;
}

.recover-classify .brand-goods{
	width: 100%;
	height: 352px;
	display: flex;
}

.recover-classify .goods-item{
	width: 245px;
	height: 352px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
}

.recover-classify .goods-item:hover .slide-group-show{
	display: block;
}

.recover-classify .goods-img{
	width: 150px;
	height: 150px;
}

.recover-classify .item-model{
	width: 85%;
	font-size: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-top: 10px;
	text-align: center;
}

.recover-classify .item-price{
	font-size: 14px;
	color: #757575;
	margin-top: 20px;
}

.recover-classify .item-price .price{
	color: #f10e0e;
	margin-left: 6px;
}

.recover-classify .slide-group-show{
	display: none;
}

.recover-classify .slide-group-show .slide-inner{
	width: 245px;
	height: 352px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 99;
	position: absolute;
	top: 0;
	left: 0;
	background-color: #fff;
}

.recover-classify .slide-group-show img{
	width: 150px;
	height: 150px;
}

.recover-classify .slide-group-show p{
	font-size: 16px;
	font-weight: bold;
	color: #fc6e42;
	margin-top: 20px;
}

.m-main-title{
	width: 1226px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 60px auto 0;
}

.m-main-title .title{
	font-size: 36px;
	font-weight: bold;
	color: #504A4D;
}

.m-main-title .line{
	width: 100px;
	height: 2px;
	background: linear-gradient(to right,#fff,#3C78EB,#fff);
	margin-top: 10px;
}

.m-main-title .tag{
	color: #3d3d3d;
	font-size: 14px;
	margin-top: 10px;
}

.m-day-wrap,
.m-comment-warp,
.m-serve-warp{
	width: 100%;
	background-color: #fff;
}

.m-day-wrap .m-day-content{
	width: 1226px;
	margin: 30px auto 0;
	padding: 80px 0;
	display: flex;
	justify-content: space-between;
}

.m-day-wrap .m-day-content .slider-item{
	width: 390px;
	height: 216px;
	cursor: pointer;
}

.m-comment-warp .m-comment-content{
	width: 1226px;
	margin: 30px auto 0;
	display: flex;
	padding: 40px 0;
}

.m-comment-content .comment-left{
	flex: 3;
	margin-right: 20px;
}

.comment-left .comment-column{
	display: flex;
	justify-content: space-between;
}

.comment-left .comment-item{
	width: 290px;
	height: 146px;
	margin-top: 14px;
	padding: 16px;
	box-sizing: border-box;
	border-radius: 10px;
	box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
	display: flex;
	flex-direction: column;
}

.comment-left .comment-item-top{
	display: flex;
}

.comment-left .comment-item-top .user-img img{
	width: 47px;
	height: 47px;
	border-radius: 47px 14px 47px 47px;
}

.comment-left .comment-item-top .user-info{
	margin-left: 16px;
}

.comment-left .comment-item-bottom{
	padding-top: 10px;
	font-size: 14px;
	color: #999;
}

.m-comment-content .comment-right{
	flex: 1;
}

.comment-right .trade-header{
	display: flex;
	align-items: center;
	justify-content: center;
}

.comment-right .trade-header .trade-title{
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin: 0 8px;
}

.comment-right .trade-header .line{
	width: 30px;
	height: 1px;
	background-color: #333;
}

.trade-list{
	height: 468px;
	overflow: hidden;
}

.comment-right .trade-item{
	width: 100%;
	padding: 16px 0;
	border-bottom: 1px dashed #e0e0e0;
	display: flex;
}

.comment-right .trade-item img{
	width: 80px;
	height: 80px;
}

.comment-right .trade-item .trade-item-info{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-left: 20px;
}

.m-serve-warp .m-serve-content{
	width: 1226px;
	margin: 30px auto 0;
	display: flex;
	justify-content: space-between;
	padding-top: 20px;
}

.m-serve-warp .m-serve-content .serve-img{
	width: 250px;
	height: 460px;
}
</style>
